if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
          fetch(routes.cart_add_url, config)
  .then((response) => response.json())
  .then((response) => {
    console.log(response);
      if (response.properties && response.properties['Delivery Date']) {
       // console.log("sfsdfsgsgsdgsdgsg")
         /*jQuery.post('/cart/update.js', {updates: {31980915064964: 1}});
         location.reload();*/
         jQuery(".custom_product .product-form__submit").click();
      }
    jQuery.getJSON('/cart.js', function(cart) {
      cart.items.forEach(function(item) {
        // Check if element.properties is an array and not null
        if (item.properties && item.properties['Delivery Date']) {
          $(".cart_drawer_checkbox1").hide();
          // $(".cart_drawer_checkbox2").show();
           setTimeout(() => {
             $(".cart_drawer_checkbox2").show();
          // $(".addProduct").text("Special Delivery Fess is Added in checkout page")
           },2000)
        }
      });
    });

    // Rest of the code remains unchanged
    if (response.status) {
      // Handle errors
      // ...
    } else if (!this.cart) {
      window.location = window.routes.cart_url;
      return;
    }

    if (!this.error)
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
    this.error = false;
    const quickAddModal = this.closest('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        () => {
          setTimeout(() => {
            this.cart.renderContents(response);
            console.log("contentRender",response)
            // $(".addProduct").text("Special Delivery Fess is Added in checkout page")
          });
        },
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      this.cart.renderContents(response);
      console.log("sdfsdfsf",response)
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
  });
        // fetch(`${routes.cart_add_url}`, config)
        //   .then((response) => response.json())
        //   .then((response) => {
        //     //console.log("sasa",response);
        //     jQuery.getJSON('/cart.js', function(cart) {
        //         cart.items.forEach(function(item) {
        //           // Check if element.properties is an array and not null
        //           if (item.properties && item.properties['Delivery Date']) {
        //           $(".cart_drawer_checkbox1").hide()
        //         }
        //         });
        //       });
        //     if (response.status) {
        //       publish(PUB_SUB_EVENTS.cartError, {
        //         source: 'product-form',
        //         productVariantId: formData.get('id'),
        //         errors: response.errors || response.description,
        //         message: response.message,
        //       });
        //       this.handleErrorMessage(response.description);

        //       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        //       if (!soldOutMessage) return;
        //       this.submitButton.setAttribute('aria-disabled', true);
        //       this.submitButton.querySelector('span').classList.add('hidden');
        //       soldOutMessage.classList.remove('hidden');
        //       this.error = true;
        //       return;
        //     } else if (!this.cart) {
        //       window.location = window.routes.cart_url;
        //       return;
        //     }

        //     if (!this.error)
        //       publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
        //     this.error = false;
        //     const quickAddModal = this.closest('quick-add-modal');
        //     if (quickAddModal) {
        //       document.body.addEventListener(
        //         'modalClosed',
        //         () => {
        //           setTimeout(() => {
        //             this.cart.renderContents(response);
        //           });
        //         },
        //         { once: true }
        //       );
        //       quickAddModal.hide(true);
        //     } else {
        //       this.cart.renderContents(response);
        //     }
        //   })
        //   .catch((e) => {
        //     console.error(e);
        //   })
        //   .finally(() => {
        //     this.submitButton.classList.remove('loading');
        //     if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //     if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //     this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        //   });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
